import type { User } from '@auth0/auth0-spa-js';

export const initialAuthState = {
  error: null,
  isAuthenticated: false,
};

export type AuthState = {
  error: Error | null;
  isAuthenticated: boolean;
  user?: User;
};
